/*
==========================================
Custom main-product.liquid
==========================================
*/

window.addEventListener("DOMContentLoaded", () => {
  const productForm = document.querySelector("[id^='AddToCartForm']");
  if (productForm) {
    productForm.addEventListener("submit", (event) => {
      event.preventDefault();
      event.target.querySelectorAll('[type="submit"]').forEach((button) => {
        button.setAttribute("disabled", true);
      });

      const variant_id = Number(
          event.target.querySelector('[name="id"]').value
        ),
        variant_selling_plan = document.getElementById(
          "mikawaya-hidden-selling-plan-id"
        ),
        form_qty = 1;

      let formData = {
        items: [
          {
            id: variant_id,
            quantity: form_qty,
          },
        ],
      };
      if (variant_selling_plan)
        formData.items[0].selling_plan = Number(variant_selling_plan.value);

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          dataType: "json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && typeof data.items === "undefined") {
            alert("在庫を超えて購入できませんでした。");
          } else {
            // ポップアップ通知
            const productInfo = data.items[0];
            document.getElementById("add-cart-announce--img").src =
              productInfo.featured_image ? productInfo.featured_image.url : "";
            document.getElementById("add-cart-announce--img").alt =
              productInfo.title;
            document.getElementById("add-cart-announce--text").textContent =
              productInfo.title;
            document.getElementById(
              "add-cart-announce--quantity"
            ).textContent = `数量:${productInfo.quantity}`;
            document
              .querySelector(".c-add-cart-announce-dialog__wrapper")
              .classList.add("open");
            document.querySelector(
              ".c-add-cart-announce-dialog__wrapper"
            ).dataset.opening_timer = 0;

            // カートの数量表記を変更
            document.querySelectorAll(".cart-link__bubble").forEach((elem) => {
              let currentCartItems = parseInt(elem.textContent);
              elem.textContent = currentCartItems + form_qty;
              if (
                elem.classList.contains("cart-link__bubble--visible") === false
              )
                elem.classList.add("cart-link__bubble--visible");
            });
          }
          event.target.querySelectorAll('[type="submit"]').forEach((button) => {
            button.removeAttribute("disabled");
          });
        })
        .catch((error) => {
          alert("エラーが発生しました。");
          console.error("Error:", error);
          event.target.querySelectorAll('[type="submit"]').forEach((button) => {
            button.removeAttribute("disabled");
          });
        });
    });
  }
});
